import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@chargify/custom-ui-components';
import { DetailRow } from '../DetailRow';

export type Props = {
  /**
   * Base plan price
   */
  basePlanPrice: string;
  /**
   * Expiration date
   */
  expirationDate: string;
};

const Expired = ({ basePlanPrice, expirationDate }: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);

  return (
    <Box marginTop={5}>
      <DetailRow
        label={{
          value: t('subscription_details.expiration_date'),
        }}
        value={{
          value: expirationDate,
          color: 'black.main',
          fontWeight: 0,
        }}
      />
      <DetailRow
        label={{
          value: t('subscription_details.base_plan_price'),
        }}
        value={{
          value: basePlanPrice,
          color: 'gray.dark',
          fontWeight: 3,
        }}
      />
    </Box>
  );
};

export default Expired;
